export default "__VITE_ASSET__bff36256__"